module.exports = __webpack_public_path__ + "static/media/ds-8-powermatic.6f46e6ee.png";